import React, { useContext, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import UserContext from "../context/UserContext";
import { TituloPagina } from "./funciones/Funciones";
import MensajeError from "./UI/MensajeError";
import MensajeGrabando from "./UI/MensajeGrabando";
import usePostURL from "../hooks/usePostURL";
import styles from "./Inicio.module.css";

const NoSession = () => {
  const loginContext = useContext(UserContext);
  const { isGrabando, erroresPost, postData, resetErroresPost } = usePostURL();
  const [sesionVencida, setSesionVencida] = useState(false);

  console.log("NoSession", loginContext, sesionVencida)

  useEffect(() => {
    document.title = TituloPagina(NoSession.name);
  }, []);

  useEffect(() => {
    resetErroresPost();
  }, [resetErroresPost]);

  //console.log("NoSession", sesionVencida, loginContext);


  useEffect(() => {
    const usuarioDeslogueado = () => {
      loginContext.UsuarioDeslogueadoHandler();
      Navigate("/");
    }
    if (!sesionVencida) {
      alert("Sesión vencida");
      setSesionVencida(true);
      postData("logout", null, usuarioDeslogueado);
    }
  }, [sesionVencida, postData, loginContext]);

  return (
    <div className={`${styles.contenedor}`}>
      {loginContext.usuario !== null && (
        <React.Fragment>
          <div className={`${styles.nosession}`}>Sesión vencida</div>
        </React.Fragment>
      )}
      <MensajeGrabando estilo={`${styles.cargando}`} isCargando={isGrabando} />
      <MensajeError estilo={`${styles.error}`} errores={erroresPost} />
    </div>
  );
};

export default NoSession;
